<template>
    <NuxtImg
        src="https://revi.rvstatic.com/aihomedesign/header-icons/logo.svg"
        width="144"
        height="28"
        alt="AI HomeDesign"
    />
</template>

<script setup lang="ts"></script>
